export const PHONE_DISPLAY = "+32 489 56 78 88";
export const PHONE_DISPLAY_SHORT = "0489 56 78 88";
export const PHONE_TEL = "tel:+32489567888";
export const PHONE_INTERNATIONAL = "+32489567888";
export const WHATSAPP_URL =
  "https://wa.me/32489567888?text=Bonjour%2C%20je%20souhaite%20obtenir%20des%20informations%20sur%20le%20service%20de%20tarification%20AVELIS.";
export const WHATSAPP_CARD_URL = `https://wa.me/32489567888?text=${encodeURIComponent(
  "Bonjour, je souhaite en savoir plus sur les services de tarification infirmière d'AVELIS."
)}`;
export const EMAIL = "contact@avelis.be";
export const EMAIL_MAILTO =
  "mailto:contact@avelis.be?subject=Demande%20d%27information%20AVELIS";
export const EMAIL_MAILTO_PLAIN = `mailto:${EMAIL}`;
export const WEBSITE_URL = "https://avelis.be";
export const WEBSITE_DISPLAY = "www.avelis.be";
export const CARD_URL = "https://avelis.be/carte";

export const VCARD = {
  name: "AVELIS",
  org: "AVELIS — by DK Soins SRL",
  title: "Tarification infirmière",
  note: "Accompagnement et facturation pour infirmiers indépendants",
  filename: "AVELIS-Contact.vcf",
};

export const buildVcf = (photoBase64) =>
  [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${VCARD.name};;;;`,
    `FN:${VCARD.name}`,
    `ORG:${VCARD.org}`,
    `TITLE:${VCARD.title}`,
    `TEL;TYPE=WORK,VOICE:${PHONE_INTERNATIONAL}`,
    `EMAIL;TYPE=WORK:${EMAIL}`,
    `URL:${WEBSITE_URL}`,
    `NOTE:${VCARD.note}`,
    photoBase64 ? `PHOTO;ENCODING=b;TYPE=PNG:${photoBase64}` : null,
    "END:VCARD",
  ]
    .filter(Boolean)
    .join("\r\n");
